import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Spin,Alert,Progress,Icon } from 'antd';
import style from './index.css'
let timer = null
let container = 'spanerModal_outer'
let wraper = 'spanerModal'
// 关闭方法
const close = () => {
  let outer  = document.getElementById(container);
  var inner = document.getElementById(wraper);
  outer.removeChild(inner);
  timer = null
}
// 循环定时器
const delay = (time=5, beforeClose) => {
  setTimeout(()=>{
    if(beforeClose) {
      let done = (type=true) => {
        if(type) return close()
          // 执行下个循环
        return delay(time, beforeClose)
      }
      beforeClose(done)
    }else{
      close()
    }
  },time*1000)
}

const antIcon = <Icon type="sync" style={{ fontSize: 24 }} spin />;

class LoadingDom extends Component {
  state = {
    count:0,
  }
  componentDidMount(){
    timer = setInterval(()=>{
      let {count} = this.state
      if(count===100){
        this.setState({
          count:0
        })
      }else{
        this.setState(state=>{
          return {
            count: state.count+1
          }
        })
      }
    },330)
  }
  render() {
    let {tip,percent} = this.props
    let {count} = this.state
    let computedTip = percent?(tip + count + ' %'):tip
    return (
      <div id={wraper} className='ant-modal-mask'>
        <div className='ant-modal-wrap'>
          <div className={style.spaner_outer}>
            <Spin tip={computedTip} className={style.spaner} spin={true} indicator={antIcon} size="large"/>
          </div>
        </div>
      </div>
    )
  }
}


export const loading = ({visible,time, tip='数据正在同步中 ', percent=false},beforeClose) => {
  // 关闭
  if(!visible){
    if(!beforeClose) return close()
    let done = (type=true) => {
      if(type) return close()
    }
    return beforeClose(done)
  }
  // 判断loading节点是否存在，没有则创建节点
  let div = null
  if(!document.getElementById(container)){
    div = document.createElement('div')
    div.id = container
  }else{
    div = document.getElementById(container)
  }
  document.body.appendChild(div)
  // 延迟执行回调
  if(time){
    delay(time,beforeClose)
  }
  ReactDOM.render(
    <LoadingDom tip={tip} percent={percent}></LoadingDom>,
    div
  )
}


// WEBPACK FOOTER //
// ./apps/pages/component/Loading/index.js